// extracted by mini-css-extract-plugin
export default {"root":"src__components__input__phone-input__root","input":"src__components__input__phone-input__input","countrySelect":"src__components__input__phone-input__countrySelect"};